import { toPayloadDateBroker } from '@energy-stacks/shared';
import CardWidget from '../CardWidget';
import { useGetChargingSuccessRateTimeSlicesQuery } from '@energy-stacks/broker/feature-dashboard-data';
import { IconActivity } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface SuccessRateWidgetProps {
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export const SuccessRateWidget = ({
  startDate,
  endDate,
}: SuccessRateWidgetProps) => {
  const { t } = useTranslation('dashboard');

  const { data, isLoading } = useGetChargingSuccessRateTimeSlicesQuery(
    {
      from: startDate ? toPayloadDateBroker(startDate) : undefined,
      to: endDate ? toPayloadDateBroker(endDate) : undefined,
    },
    { refetchOnMountOrArgChange: true }
  );

  const definedRates =
    data?.filter(
      (slice): slice is typeof slice & { chargingSuccessRate: number } =>
        slice.chargingSuccessRate != null
    ) ?? [];
  const totalSuccessRate = definedRates.reduce(
    (sum, slice) => sum + slice.chargingSuccessRate,
    0
  );
  const averageSuccessRate =
    definedRates.length > 0 ? totalSuccessRate / definedRates.length : 0;

  return (
    <CardWidget
      color="blue"
      isLoading={isLoading}
      value={Math.round(averageSuccessRate) + '%'}
      name={t('chargingSuccessRate')}
      icon={<IconActivity />}
    />
  );
};
